import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface DDSState {
	ddsIdsAttendees: string[]
	setDdsIdsAttendees: (
		attendees: string[] | ((prev: string[]) => string[]),
	) => void
	removeDdsIdAttendee: (attendeeId: string) => void
}

export const useDDSStore = create<DDSState>()(
	persist(
		(set) => ({
			ddsIdsAttendees: [],
			setDdsIdsAttendees: (attendees) =>
				set((state) => ({
					ddsIdsAttendees:
						typeof attendees === 'function'
							? attendees(state.ddsIdsAttendees)
							: attendees,
				})),
			removeDdsIdAttendee: (attendeeId) =>
				set((state) => ({
					ddsIdsAttendees: state.ddsIdsAttendees.filter(
						(id) => id !== attendeeId,
					),
				})),
		}),
		{
			name: 'ssma-dds',
		},
	),
)
